module.exports = __webpack_public_path__ + "img/app-store.498e4921.png";